import { Stack, Typography } from "@mui/material";
import React from "react";
import moment from "moment";
import GlobalConst from "../../../Core/Utils/Constants/globals";

export interface TableCellDateTimeProps {
  data: any;
  format?: string;
}

const TableCellDateTime: React.FC<TableCellDateTimeProps> = ({ data, format = undefined }) => {
  let date;
  if (data.value) {
    if (typeof data.value === "object") date = moment(data.value.date);
    else date = moment(data.value);
  }
  return (
    <>
      {data.value ? (
        <Stack>
          <Typography variant="body1">
            {date.format(format ? format.split(" ")[0] : GlobalConst.MOMENT_DATE_FORMAT_DATENOHOURS)}
          </Typography>
          <Typography variant="body2" color="text.tier">
            {date.format(GlobalConst.MOMENT_DATE_FORMAT_HOURS)}
          </Typography>
        </Stack>
      ) : (
        "-"
      )}
    </>
  );
};

export default TableCellDateTime;
